export default __webpack_public_path__ + "static/media/b_costeffective_accurate.5fe33810.png";